/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2024-10-18 14:14:20
 * @LastEditors: linxi
 * @LastEditTime: 2024-10-18 16:57:06
 */


import { API_PREFIX } from './constant'
import { Request } from './request'

export interface SelfRateInquiryListParams {
  timeHead?: any
  timeTail?: any
}

export function SelfRateInquiryList(params: SelfRateInquiryListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/paymentRatioInquiry`,
    method: 'GET',
    params,
  }
}

export interface ScanRateListParams {
  current?: any
  size?: any
  drugCategory?:any
  category?:any
  insuranceCode?:any
  startTime?:any
  endTime?:any
}

export function getTraceCodeScanRateList(body: ScanRateListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/traceCode/drugSalesScanningRate`,
    method: 'POST',
    body,
  }
}

export interface UploadRateListParams {
  current?: any
  size?: any
  drugCategory?:any
  category?:any
  startTime?:any
  endTime?:any
}

export function getTraceCodeUploadRateList(body: UploadRateListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/traceCode/drugSalesUploadRate`,
    method: 'POST',
    body,
  }
}

export interface TradeCodeListParams {
  current?: any
  size?: any
  drugCategory?:any
  category?:any
  insuranceCode?:any
  startTime?:any
  endTime?:any
}

export function getdrugTradeCodeList(body: TradeCodeListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/traceCode/drugTradeCodeList`,
    method: 'POST',
    body,
  }
}